import { format } from "date-fns";

// checkout more options for the date formatting here https://date-fns.org/v2.30.0/docs/format
export const DATE_DEFAULT_FORMAT = "yyyy-MM-dd, HH:mm:ss";

export const getFormattedDate = (date: string | Date | undefined | null) => {
  if (!date) return "";

  return format(new Date(date), DATE_DEFAULT_FORMAT);
};
